import { Component, inject } from '@angular/core';
import { AllDevicesTableComponent } from '../../partials/all-devices-table/all-devices-table.component';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { ListDevicesFacade } from '../../../../../Facades/Intune/list-devices.facade';
import { FormControl } from '@angular/forms';
import { debounceTime, filter } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [COMMON_IMPORTS, AllDevicesTableComponent],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss', '../../../../../../assets/theme/cutom/_error-container.scss'],
})
export class DashboardComponent {
  readonly facade = inject(ListDevicesFacade);

  searchControl = new FormControl<string>('');

  constructor() {
    this.initSearch();
  }

  initSearch() {
    this.searchControl
      .valueChanges.pipe(
        debounceTime(500),
        filter((value: string | null) => value !== null && (value.length === 0 || value.length >= 2)))
      .subscribe((value: string | null) => {
        this.facade.setSearchTerm(value ?? '');
      });
  }
}